// Copyright (c) 2017 Deere & Company

export default Object.freeze({
    RESET_PRODUCTS_BY_CUSTOMER_PRODUCT: 'RESET_PRODUCTS_BY_CUSTOMER_PRODUCT',
    RESET_PRODUCTS_BY_CUSTOMER_SEARCH_CUSTOMER: 'RESET_PRODUCTS_BY_CUSTOMER_SEARCH_CUSTOMER',
    RESET_PRODUCTS_BY_CUSTOMER_SEARCH_RESULTS: 'RESET_PRODUCTS_BY_CUSTOMER_SEARCH_RESULTS',
    UPDATE_PRODUCTS_BY_CUSTOMER_CLAIM_TYPES: 'UPDATE_PRODUCTS_BY_CUSTOMER_CLAIM_TYPES',
    UPDATE_PRODUCTS_BY_CUSTOMER_CREATE_CLAIM_MODAL: 'UPDATE_PRODUCTS_BY_CUSTOMER_CREATE_CLAIM_MODAL',
    UPDATE_PRODUCTS_BY_CUSTOMER_EDIT_MODAL_VISIBILITY: 'UPDATE_PRODUCTS_BY_CUSTOMER_EDIT_MODAL_VISIBILITY',
    UPDATE_PRODUCTS_BY_CUSTOMER_FILTER_QUERY: 'UPDATE_PRODUCTS_BY_CUSTOMER_FILTER_QUERY',
    UPDATE_PRODUCTS_BY_CUSTOMER_LIST_FILTER_BY: 'UPDATE_PRODUCTS_BY_CUSTOMER_LIST_FILTER_BY',
    UPDATE_PRODUCTS_BY_CUSTOMER_LIST_SORT_BY: 'UPDATE_PRODUCTS_BY_CUSTOMER_LIST_SORT_BY',
    UPDATE_PRODUCTS_BY_CUSTOMER_LIST_SORT_DIRECTION: 'UPDATE_PRODUCTS_BY_CUSTOMER_LIST_SORT_DIRECTION',
    UPDATE_PRODUCTS_BY_CUSTOMER_PRODUCT: 'UPDATE_PRODUCTS_BY_CUSTOMER_PRODUCT',
    UPDATE_PRODUCTS_BY_CUSTOMER_SEARCH_CUSTOMER: 'UPDATE_PRODUCTS_BY_CUSTOMER_SEARCH_CUSTOMER',
    UPDATE_PRODUCTS_BY_CUSTOMER_SEARCH_CUSTOMER_MODAL_VISIBILITY: 'UPDATE_PRODUCTS_BY_CUSTOMER_SEARCH_CUSTOMER_MODAL_VISIBILITY',
    UPDATE_PRODUCTS_BY_CUSTOMER_SEARCH_RESULTS: 'UPDATE_PRODUCTS_BY_CUSTOMER_SEARCH_RESULTS',
    UPDATE_PRODUCTS_BY_CUSTOMER_SHOW_PARTIAL_DATA_WARNING: 'UPDATE_PRODUCTS_BY_CUSTOMER_SHOW_PARTIAL_DATA_WARNING',
    UPDATE_PRODUCTS_BY_CUSTOMER_STATUS_CHANGE_MODAL_VISIBILITY: 'UPDATE_PRODUCTS_BY_CUSTOMER_STATUS_CHANGE_MODAL_VISIBILITY'
});



// WEBPACK FOOTER //
// ./src/product/products-by-customer/actions-list.js